import { getPlatformsAdultCached } from '@/views/harmony/harmonyLoader';

export default {
  methods: {
    isLocalAdultCheckEnvironment() {
      const hostname = window.location.hostname || '';
      const env = process.env.NODE_ENV || '';

      return env === 'development' ||
        env === 'local' ||
        hostname === 'localhost' ||
        hostname === '127.0.0.1' ||
        hostname === '::1';
    },

    checkUserAdultRedirect(isAdult, harmonySlug) {
      if (!isAdult || this.isLocalAdultCheckEnvironment()) {
        return false;
      }

      const storageKey = `adult_verified_${harmonySlug}`;
      const urlParams = new URLSearchParams(window.location.search);
      const userAgent = navigator.userAgent.toLowerCase();

      // Detectar si viene de Instagram, Facebook o TikTok - siempre redirigir
      const utmSource = urlParams.has('utm_source');
      const hasFbclid = urlParams.has('fbclid');
      const isFromTikTok = userAgent.includes('tiktok') ||
        userAgent.includes('bytedance') ||
        userAgent.includes('musical_ly');

      if (utmSource || hasFbclid || isFromTikTok) {
        // Siempre redirigir, sin importar el storage
        window.location.href = `https://hrm.fan/${harmonySlug}`;
        return true;
      }

      // Verificar si llega el parámetro ?ref=true en la URL
      const refParam = urlParams.get('ref');

      if (refParam === 'true') {
        // El usuario ya confirmó que es adulto, crear storage y permitir acceso
        const adultData = {
          harmony: harmonySlug,
          isAdult: true,
          verifiedAt: new Date().toISOString()
        };
        localStorage.setItem(storageKey, JSON.stringify(adultData));
        this.is_user_adult = true;
        return false;
      }

      // Verificar si ya existe la verificación en localStorage
      const existingData = localStorage.getItem(storageKey);

      if (existingData) {
        try {
          const data = JSON.parse(existingData);
          if (data.isAdult) {
            this.is_user_adult = true;
            return false;
          }
        } catch (error) {
          // Si hay error al parsear, eliminar el dato corrupto
          localStorage.removeItem(storageKey);
        }
      }

      // Si es contenido para adultos y no hay verificación válida, redirigir
      window.location.href = `https://hrm.fan/${harmonySlug}`;
      return true;
    },

    async getPlatformsAdult() {
      try {
        this.platformsAdult = await getPlatformsAdultCached();
      } catch (error) {
        console.log(error)
      }
    }
  }
}
